import CRUDService from "../services/base/CRUDService";

export default class MovementOrderService extends CRUDService {

  static ALL_URL = 'ton/v1/movement-orders/';

  getBaseURL() {
    return MovementOrderService.ALL_URL;
  }

}



// WEBPACK FOOTER //
// ./src/movementOrder/MovementOrderService.js